<template>
  <PageContent
    :title="$t('csr.section.banner.title')"
    :paragraphs="$t('csr.section.banner.paragraphs')"
    :title-class="titleClass"
  />
</template>

<script lang="ts">
import PageContent from '@/scripts/pages/onepager/components/PageContent.ts.vue';
import { CsrBaseComponent } from './CsrBaseComponent';

export default CsrBaseComponent.extend({
  components: {
    PageContent,
  },
  props: {
    titleClass: {
      type: String,
      default: undefined,
    },
  },
});
</script>
